const logger = {
  log: (message) => {
    if (process.env.REACT_APP_ENV === 'local') {
      console.log(message)
    }
  }
}
export default logger
